// extracted by mini-css-extract-plugin
export default {"FloorSingleView":"floor-single-view_FloorSingleView__QibCb"};